import { Mesh, Line, BufferGeometry, BufferAttribute, Vector3 } from "three";
import { Constant } from "./constant.js";

let Util = {
  disposeFun(child) {
    if (child.children.length) {
      let arr = child.children.filter((x) => x);
      arr.forEach((a) => {
        this.disposeFun(a);
      });
    }
    if (child instanceof Mesh || child instanceof Line) {
      //if (child.material.map) child.material.map.dispose()
      if (Array.isArray(child.material)) {
        Constant.MAP_NAMES.forEach((map) => {
          if (child.material[1].baseMaterial[map])
            child.material[1].baseMaterial[map].dispose();
        });
        child.material[1].baseMaterial.dispose();
      } else if (child.material.baseMaterial) {
        Constant.MAP_NAMES.forEach((map) => {
          if (child.material.baseMaterial[map])
            child.material.baseMaterial[map].dispose();
        });
        child.material.baseMaterial.dispose();
      } else {
        Constant.MAP_NAMES.forEach((map) => {
          if (child.material[map]) child.material[map].dispose();
        });
        child.material.dispose();
      }
      child.geometry.dispose();
    } else if (child.material) {
      Constant.MAP_NAMES.forEach((map) => {
        if (child.material[map]) child.material[map].dispose();
      });
      child.material.dispose();
    }
    child.removeFromParent();
  },

  get3DPointer(event, domElement) {
    if (document.pointerLockElement) {
      return {
        x: 0,
        y: 0,
        button: event.button,
      };
    } else {
      var pointer = window.event || event;

      var rect = domElement.getBoundingClientRect();
      if (event.touches && event.touches.length === 1) {
        return {
          x: ((pointer.touches[0].pageX - rect.left) / rect.width) * 2 - 1,
          y: (-(pointer.touches[0].pageY - rect.top) / rect.height) * 2 + 1,
          button: event.button,
        };
      } else {
        return {
          x: ((pointer.clientX - rect.left) / rect.width) * 2 - 1,
          y: (-(pointer.clientY - rect.top) / rect.height) * 2 + 1,
          button: event.button,
        };
      }
    }
  },

  /**
   * 屏幕坐标转世界坐标
   * @param {*} event
   * @param {*} camera 相机
   * @param {*} dis 离相机的距离
   * @returns
   */
  screenToWorld(event, domElement, camera, dis = 10) {
    // const x = event.clientX; //鼠标单击坐标X
    // const y = event.clientY; //鼠标单击坐标Y
    // // 屏幕坐标转标准设备坐标
    // const x1 = (x / window.innerWidth) * 2 - 1;
    // const y1 = -(y / window.innerHeight) * 2 + 1;

    let tempPos = this.get3DPointer(event, domElement);

    //标准设备坐标(z=0.5这个值并没有一个具体的说法)
    const stdVector = new Vector3(tempPos.x, tempPos.y, 0.5);
    const worldVector = stdVector.unproject(camera);

    //获取摄像机世界坐标
    let cameraPos = camera.getWorldPosition(new Vector3());
    //获取射线方向
    let dir = worldVector.clone().sub(cameraPos).normalize();
    //沿着射线方向延伸10个单位
    let src = cameraPos.clone().add(dir.clone().multiplyScalar(dis));
    return src;
  },

  /**
   * 角度转弧度
   */
  degToRad(angle) {
    return (angle * Math.PI) / 180;
  },

  /**
   * 弧度转角度
   * @param {*} rad
   */
  radToDeg(rad) {
    return (rad * 180) / Math.PI;
  },

  /**
   * 比较两个向量是否相等
   * @param {*} v1
   * @param {*} v2
   * @returns
   */
  vector3Equals(v1, v2) {
    if (v1.distanceTo(v2) < 0.0001) return true;
    return false;
  },

  /**
   * 将交错几何转成bufferGeometry
   * @param {*} interleavedGeometry
   */
  interleavedGeometry2BufferGeometry(interleavedGeometry) {
    let cloned = new BufferGeometry();
    cloned.setIndex(interleavedGeometry.index.clone());

    let posArray = interleavedGeometry.attributes.position.data.array;
    let stride = interleavedGeometry.attributes.position.data.stride;

    let vertex = new Float32Array(posArray);
    cloned.setAttribute("position", new BufferAttribute(vertex, stride));
    return cloned;
  },

  getOS() {
    const isVRDevice = this.isVRDevice();
    var ua = navigator.userAgent,
      isAndroid = /(?:Android)/.test(ua),
      isTablet =
        /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)),
      isPhone = /(?:iPhone)/.test(ua) && !isTablet,
      isPc = !isPhone && !isAndroid;
    return {
      isTablet: isTablet,
      isPhone: isPhone,
      isAndroid: isAndroid,
      isVRDevice: isVRDevice,
      isPc: isVRDevice ? false : isPc,
    };
  },

  isVRDevice() {
    const vrKeywords = [
      "Quest",
      "Vive",
      "PICO",
      "OculusBrowser",
      "ViveBrowser",
      "PicoBrowser",
      "VR Safari",
    ];
    return vrKeywords.some((keyword) => navigator.userAgent.includes(keyword));
  },

  /**
   * 将string类型转换成blob并返回
   * @param {String} text
   * @returns
   */
  saveString(text) {
    const blob = new Blob([text], { type: "text/plain" });
    return blob;
  },

  /**
   * 将arraybuffer转换成blob
   * @param {*} buffer
   */
  saveArrayBuffer(buffer) {
    const blob = new Blob([buffer], { type: "application/octet-stream" });
    return blob;
  },

  /**
   * 将blob通过浏览器下载 （测试用）
   * @param {Blob} blob
   * @param {String} filename 保存为文件名
   */
  async download(blob, filename) {
    const link = document.createElement("a");
    link.style.display = "none";
    document.body.appendChild(link);
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.click();
    document.body.removeChild(link);
  },
};

export default Util;
